import { render, staticRenderFns } from "./TemporaryCountingDetail.vue?vue&type=template&id=5bb67163"
import script from "./TemporaryCountingDetail.vue?vue&type=script&lang=js"
export * from "./TemporaryCountingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports